import { EnahncedLiveFeedEvent, useLiveFeed } from './useLiveFeed';
import { LiveFeedEventType } from '@repo/types';
import { Image } from '@ui/common/components/Image';

export const LiveFeed = () => {
  const liveFeed = useLiveFeed();

  return (
    <div className="live-feed">
      {!liveFeed?.events || liveFeed.events.length === 0 ? (
        <span>There are no events yet</span>
      ) : (
        <ul>
          {liveFeed?.events
            ?.filter((event) => !!event.match)
            .map((event, index) => (
              <li key={`${event.eventType}-${event.minute}-${index}`}>
                <LiveFeedEventCard event={event} />
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

const LiveFeedEventCard = ({ event }: { event: EnahncedLiveFeedEvent }) => {
  switch (event.eventType) {
    case LiveFeedEventType.Goal:
    case LiveFeedEventType.GoalFromPenalty:
    case LiveFeedEventType.OwnGoal:
      // eslint-disable-next-line no-case-declarations
      let icon = '';
      if (event.eventType === LiveFeedEventType.GoalFromPenalty) {
        icon = '/penalty-goal.png';
      } else if (event.eventType === LiveFeedEventType.OwnGoal) {
        icon = '/own-goal-icon.svg';
      } else {
        icon = '/ball-icon.svg';
      }

      return (
        <div className={'live-feed__event-container'}>
          <div className={'live-feed__event-top-container'}>
            <div className={'live-feed__home-team-container'}>
              <div className={'live-feed__event-type-container'}>
                <Image src={icon} alt="goal" width={'100%'} style={{ maxWidth: '20px', maxHeight: '20px' }} />(
                {event.minute}')
              </div>
              <div className={'live-feed__team-container--home'}>
                {event.person?.teamId === event.match?.homeTeam?.id ? (
                  <b>{event.match?.homeTeam?.shortName}</b>
                ) : (
                  event.match?.homeTeam?.shortName
                )}
              </div>
            </div>
            <span className={'live-feed__score-container'}>
              {event.person?.teamId === event.match?.homeTeam?.id && (
                <>
                  <b>{event.score?.home}</b> - {event.score?.away}
                </>
              )}

              {event.person?.teamId === event.match?.awayTeam?.id && (
                <>
                  {event.score?.home} - <b>{event.score?.away}</b>
                </>
              )}
            </span>
            <div className={'live-feed__away-team-container'}>
              <div className={'live-feed__team-container--away'}>
                {event.person?.teamId === event.match?.awayTeam?.id ? (
                  <b>{event.match?.awayTeam?.shortName}</b>
                ) : (
                  event.match?.awayTeam?.shortName
                )}
              </div>
            </div>
          </div>
          <div className={'live-feed__event-bottom-container'}>
            <span className={'live-feed__player-names'}>{event.person?.name}</span>
          </div>
        </div>
      );
    case LiveFeedEventType.YellowCard:
    case LiveFeedEventType.FirstYellowCard:
      return (
        <div className={'live-feed__event-container'}>
          <div className={'live-feed__event-top-container'}>
            <div className={'live-feed__home-team-container'}>
              <div className={'live-feed__event-type-container'}>
                <div className={'match-overview__yellow-card'} />({event.minute}')
              </div>
              <div className={'live-feed__team-container--home'}>
                {event.person?.teamId === event.match?.homeTeam?.id ? (
                  <b>{event.match?.homeTeam?.shortName}</b>
                ) : (
                  event.match?.homeTeam?.shortName
                )}
              </div>
            </div>
            <span className={'live-feed__score-container'}>
              {event.person?.teamId === event.match?.homeTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}

              {event.person?.teamId === event.match?.awayTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}
            </span>
            <div className={'live-feed__away-team-container'}>
              <div className={'live-feed__team-container--away'}>
                {event.person?.teamId === event.match?.awayTeam?.id ? (
                  <b>{event.match?.awayTeam?.shortName}</b>
                ) : (
                  event.match?.awayTeam?.shortName
                )}
              </div>
            </div>
          </div>
          <div className={'live-feed__event-bottom-container'}>
            <span className={'live-feed__player-names'}>{event.person?.name}</span>
          </div>
        </div>
      );
    case LiveFeedEventType.SecondYellowCard:
      return (
        <div className={'live-feed__event-container'}>
          <div className={'live-feed__event-top-container'}>
            <div className={'live-feed__home-team-container'}>
              <div className={'live-feed__event-type-container'}>
                <Image
                  src={'/second-yellow-card.png'}
                  alt="goal"
                  width={'100%'}
                  style={{ maxWidth: '20px', maxHeight: '20px' }}
                />
                ({event.minute}')
              </div>
              <div className={'live-feed__team-container--home'}>
                {event.person?.teamId === event.match?.homeTeam?.id ? (
                  <b>{event.match?.homeTeam?.shortName}</b>
                ) : (
                  event.match?.homeTeam?.shortName
                )}
              </div>
            </div>
            <span className={'live-feed__score-container'}>
              {event.person?.teamId === event.match?.homeTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}

              {event.person?.teamId === event.match?.awayTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}
            </span>
            <div className={'live-feed__away-team-container'}>
              <div className={'live-feed__team-container--away'}>
                {event.person?.teamId === event.match?.awayTeam?.id ? (
                  <b>{event.match?.awayTeam?.shortName}</b>
                ) : (
                  event.match?.awayTeam?.shortName
                )}
              </div>
            </div>
          </div>
          <div className={'live-feed__event-bottom-container'}>
            <span className={'live-feed__player-names'}>{event.person?.name}</span>
          </div>
        </div>
      );
    case LiveFeedEventType.RedCard:
      return (
        <div className={'live-feed__event-container'}>
          <div className={'live-feed__event-top-container'}>
            <div className={'live-feed__home-team-container'}>
              <div className={'live-feed__event-type-container'}>
                <div className={'match-overview__red-card'} />({event.minute}')
              </div>
              <div className={'live-feed__team-container--home'}>
                {event.person?.teamId === event.match?.homeTeam?.id ? (
                  <b>{event.match?.homeTeam?.shortName}</b>
                ) : (
                  event.match?.homeTeam?.shortName
                )}
              </div>
            </div>
            <span className={'live-feed__score-container'}>
              {event.person?.teamId === event.match?.homeTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}

              {event.person?.teamId === event.match?.awayTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}
            </span>
            <div className={'live-feed__away-team-container'}>
              <div className={'live-feed__team-container--away'}>
                {event.person?.teamId === event.match?.awayTeam?.id ? (
                  <b>{event.match?.awayTeam?.shortName}</b>
                ) : (
                  event.match?.awayTeam?.shortName
                )}
              </div>
            </div>
          </div>
          <div className={'live-feed__event-bottom-container'}>
            <span className={'live-feed__player-names'}>{event.person?.name}</span>
          </div>
        </div>
      );
    case LiveFeedEventType.Substitution:
      return (
        <div className={'live-feed__event-container'}>
          <div className={'live-feed__event-top-container'}>
            <div className={'live-feed__home-team-container'}>
              <div className={'live-feed__event-type-container'}>
                <Image src="/loop-icon.svg" alt="substitution" width={20} height={20} />({event.minute}')
              </div>
              <div className={'live-feed__team-container--home'}>
                {event.person?.teamId === event.match?.homeTeam?.id ? (
                  <b>{event.match?.homeTeam?.shortName}</b>
                ) : (
                  event.match?.homeTeam?.shortName
                )}
              </div>
            </div>
            <span className={'live-feed__score-container'}>
              {event.person?.teamId === event.match?.homeTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}

              {event.person?.teamId === event.match?.awayTeam?.id && (
                <>
                  {event.match?.score?.current?.home} - {event.match?.score?.current?.away}
                </>
              )}
            </span>
            <div className={'live-feed__away-team-container'}>
              <div className={'live-feed__team-container--away'}>
                {event.person?.teamId === event.match?.awayTeam?.id ? (
                  <b>{event.match?.awayTeam?.shortName}</b>
                ) : (
                  event.match?.awayTeam?.shortName
                )}
              </div>
            </div>
          </div>
          <div className={'live-feed__event-bottom-container'}>
            <span className={'live-feed__first-player-name'}>{event.personOff?.name}</span>
            <Image src="/subs-arrows.png" alt="arrow" width={30} height={30} />
            <span className={'live-feed__second-player-name'}>{event.person?.name}</span>
          </div>
        </div>
      );
    default:
      return null;
  }
};
